// import "../../node_modules/van11y-accessible-modal-window-aria/dist/van11y-accessible-modal-window-aria.js";
import "../vendors/custom-van11y-accessible-modal-window-aria";